import { DeviceModelId } from "@ledgerhq/devices";
export function isSyncOnboardingSupported(deviceModelId) {
    return [DeviceModelId.stax, DeviceModelId.europa].includes(deviceModelId);
}
//# sourceMappingURL=isSyncOnboardingSupported.js.map